import { render, staticRenderFns } from "./q-ans-add-screen.html?vue&type=template&id=139dbbb1&scoped=true&external"
import script from "./q-ans-add-screen.js?vue&type=script&lang=js&external"
export * from "./q-ans-add-screen.js?vue&type=script&lang=js&external"
import style0 from "./q-ans-add-screen.scss?vue&type=style&index=0&id=139dbbb1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139dbbb1",
  null
  
)

export default component.exports